module.exports = __webpack_public_path__ + "img/Fintech-network-tw.70b18144.png";